import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleSidebar } from 'config/slice/sidebar'

export default function Header() {

    const [menu, setMenu] = React.useState(false)

    const dispatch = useDispatch()

    const miniSidebar = () => dispatch(toggleSidebar())

    const showMenu = () => {
        document.querySelector('.layout-fixed .main-sidebar').style.left = '0px'
        document.querySelector('.content-wrapper').style.setProperty("margin", "0 0 0 250px", "important")
        document.querySelector('.main-header').style.setProperty("margin", "0 0 0 250px", "important")
        document.querySelector('.mobile-menu').style.margin = '0 0 0 250px'
        setMenu(true)
    }
    const hideMenu = () => {
        document.querySelector('.layout-fixed .main-sidebar').style.left = '-250px'
        document.querySelector('.content-wrapper').style.setProperty("margin", "0 0 0 0px", "important")
        document.querySelector('.main-header').style.setProperty("margin", "0 0 0 0px", "important")
        document.querySelector('.mobile-menu').style.margin = '0 0 0 0px'
        setMenu(false)
    }

    return (
        <>
            {
                menu
                    ? (<div className='mobile-menu' onClick={hideMenu}><span><i className="fas fa-close fs-4 text-dark text-wa-light-blue"></i></span></div>)
                    : (<div className='mobile-menu' onClick={showMenu}><span><i className="fas fa-bars fs-4 text-dark text-wa-light-blue"></i></span></div>)
            }

            {/* <!-- Navbar --> */}
            <nav className="main-header navbar navbar-expand navbar-white navbar-light wa-bg-content border-0">
                {/* <!-- Left navbar links --> */}
                <ul className="navbar-nav">
                    <li className="nav-item" onClick={miniSidebar} style={{ visibility: "hidden" }}>
                        <a className="nav-link" href="#" role="button" data-widget="pushmenu" data-auto-collapse-size="992" ><i className="fas fa-bars"></i></a>
                    </li>
                </ul>
            </nav>
            {/* <!-- /.navbar --> */}
        </>
    )
}
